import { useEffect } from 'react';

export function useGlobalViewPermission({
  selectedView,
  userDetails,
  setIsGlobalViewActionDisable,
  setNotPermissionForGlobalActivity,
}: {
  selectedView: { isGlobal: boolean };
  userDetails: { roleIds: number[] };
  setIsGlobalViewActionDisable: (value: boolean) => void;
  setNotPermissionForGlobalActivity: (value: boolean) => void;
}) {
  useEffect(() => {
    if (selectedView?.isGlobal) {
      if (userDetails?.roleIds?.includes(1)) {
        setIsGlobalViewActionDisable(false);
      } else {
        setIsGlobalViewActionDisable(true);
      }
    } else {
      setIsGlobalViewActionDisable(false);
    }

    if (userDetails?.roleIds?.includes(1)) {
      setNotPermissionForGlobalActivity(false);
    } else {
      setNotPermissionForGlobalActivity(true);
    }
  }, [userDetails?.roleIds, selectedView]);
}
